/**
 * Created by asiulik on 02.08.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../utils', './parketFiltersConfig'], function($, _, EventEmitter, Utils, FiltersConfig){

    var $window = $(window);

    function ParketFiltersContent(){
        var _this = this;
        this.on('parketfinder:filters:reload', function(){
            _this.reload();
        });
    }

    ParketFiltersContent.prototype = _.clone(EventEmitter.prototype);

    ParketFiltersContent.prototype.init = function(){

        var _this = this;

        this.$finder = $(FiltersConfig.parketfinderSelector);

        this.$filtersContainer = $(FiltersConfig.contentContainerSelector);
        this.$filtersSidebar = $(FiltersConfig.filtersContainerSelector);

        if(!this.$filtersContainer.length) return;

        this.$preloader = this.$filtersContainer.find(FiltersConfig.preloaderSelector);

        this.filtersPreloaderInstance = new ParketFiltersPreloader();

        this.bindEvents();

        this.detectLoadMoreAction();

    };

    ParketFiltersContent.prototype.reload = function(){
        this.$preloader = this.$filtersContainer.find(FiltersConfig.preloaderSelector);
        this.bindEvents();

        this.loadingNewPagePending = false;
        this.detectLoadMoreAction();
    };

    ParketFiltersContent.prototype.bindEvents = function(){

        var _this = this;

        this.$filtersLinks = this.$filtersSidebar.find(FiltersConfig.filtersLinkSelector);
        this.$searchItems = $(FiltersConfig.searchItemsSelector);

        this.$filtersLinks.on({

            click: function(e){

                var $this = $(this);

                e.preventDefault();
                e.stopPropagation();

                if(_this.pending) return;

                _this.changeFilterDataAction($this);

            }
        });

        this.$searchItems.on({

            change: function(){

                var $this = $(this);
                var currentValue = $this.val();

                var currentPageUrl = window.location.href;

                var searchQueryCurrentInUrl = Utils.getQueryStringParams('searchQuery', currentPageUrl);
                var searchQueryPageParam = Utils.getQueryStringParams('page', currentPageUrl);

                if(searchQueryCurrentInUrl){
                    currentPageUrl = Utils.removeURLParameter(currentPageUrl, 'searchQuery');
                }

                if(searchQueryPageParam) {
                    currentPageUrl = Utils.removeURLParameter(currentPageUrl, 'page');
                }

                var newUrlValue = currentValue ? Utils.addQueryStringParamsToUrl('searchQuery', currentValue, currentPageUrl) : currentPageUrl;

                var $link = $('<a>');
                $link.attr('href', newUrlValue);

                _this.changeFilterDataAction($link);

            }
        });

        var _this = this;

        function _checkScrollPosition(){
            _this.detectLoadMoreAction();
        }

        var _lazyScroll = _.throttle(_checkScrollPosition, 500);
        $window.off('scroll.ParketFiltersContent');
        $window.on('scroll.ParketFiltersContent', _lazyScroll);

    };

    ParketFiltersContent.prototype.detectLoadMoreAction = function(){

        var _this = this;

        if ($window.scrollTop() + $window.height() >= _this.$filtersContainer.height() - 700) {
            _this.loadFinderNextPage();
        }

    };

    ParketFiltersContent.prototype.loadFinderNextPage = function(){

        var _this = this;

        if(this.loadingNewPagePending) return;
        this.loadingNewPagePending = true;

        var $nextPageLink = this.$filtersContainer.find('#loadMoreFilterData');

        if(!$nextPageLink.length) {
            $window.off('scroll.ParketFiltersContent');
            return;
        }

        $nextPageLink.hide();

        var requestUrl = $nextPageLink.attr('href');

        $.get(requestUrl).then(function(data){

            var $data = $(data);
            var $contentHTML = $data.find(FiltersConfig.contentContainerSelector + ' .row');
            _this.$filtersContainer.find('#loadMoreItemsPrelaoder').remove();
            $nextPageLink.remove();
            $contentHTML.wrapInner('<div class="load-more-animation"/>');
            _this.$filtersContainer.find('> .row').append($contentHTML.html());

            _this.loadingNewPagePending = false;

            _this.emit('parketfinder:loadMore:matchSelected');

        });

    };

    ParketFiltersContent.prototype.changeFilterDataAction = function($link){

        var _this = this;

        this.pending = true;
        this.filtersPreloaderInstance.showPreloader(_this.$preloader);

        this.$finder.addClass(FiltersConfig.finderPendingActiveClass);

        // Utils.scrollPositionAnimate(0);

        this.getFiltersData($link.attr('href')).then(function(htmlObj){

            window.tracking.trackGTM({
                'event': 'finder',
                'action': 'finderAction',
                'value': $link.attr('href')
            });

            window.tracking.trackGA([
                'send',
                'event',
                'finder',
                'finderAction',
                $link.attr('href')
            ]);

            var $filtersResponse = htmlObj.filters;
            var $contentResponse = htmlObj.content;

            _this.$filtersContainer.html($contentResponse.html());
            _this.$filtersSidebar.html($filtersResponse.html());

            _this.filtersPreloaderInstance.hidePreloader(_this.$preloader);

            _this.pending = false;

            _this.$finder.removeClass(FiltersConfig.finderPendingActiveClass);

            _this.emit('parketfinder:filters:reload', $link.attr('href'));

        });

    };

    ParketFiltersContent.prototype.getFiltersData = function(url){

        var _this = this;
        var dfd = jQuery.Deferred();

        $.get(url).then(function(data){

            setTimeout(function(){

                return dfd.resolve({
                    content: $(data).find(FiltersConfig.contentContainerSelector),
                    filters: $(data).find(FiltersConfig.filtersContainerSelector)
                });

            })

        });

        return dfd.promise();

    };

    function ParketFiltersPreloader(){}

    ParketFiltersPreloader.prototype.showPreloader = function($element){
        $element.addClass('finder__content__preloader--show');
    };

    ParketFiltersPreloader.prototype.hidePreloader = function($element){
        $element.removeClass('finder__content__preloader--show');
    };

    return ParketFiltersContent;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/parketFilters/parketFiltersContent.js